import { useMemo } from "react";
import { useColumns } from "app/hooks/useColumns";
import { useTables } from "app/hooks/useTables";
import { TargetColumn } from "../types/formBuilder.types";

export const useTargetColumns = (targetTable: string): TargetColumn[] => {
    const { data: allColumns = [] } = useColumns();
    const { data: tables = [] } = useTables();

    return useMemo(() => {
        if (!targetTable) return [];

        const table = tables.find((candidate: any) => candidate.name === targetTable || candidate.id === targetTable);
        const tableId = table?.id || "";
        const tableName = table?.name || targetTable;

        return allColumns
            .filter((column: any) =>
                column?.sys_table_id === tableId ||
                column?.sys_table?.name === tableName ||
                column?.sys_table_name === tableName ||
                column?.table_name === tableName
            )
            .map((column: any) => ({
                id: String(column.id || column.name),
                name: String(column.name || ""),
                // PRIM-004 (rodada 4): intencionalmente NÃO traduzido aqui. Este hook produz o
                // modelo de dados de TargetColumn consumido por vários componentes (ColumnMapper,
                // PropertyPanel, RuleBuilder...); embutir a tradução na origem apagaria a key
                // original, que o TranslatableInput e outros editores de metadado ainda precisam
                // para saber qual chave estão editando. A tradução acontece nos consumidores, na
                // borda de renderização (ex.: PropertyPanel.tsx columnLabel/translateMetadataLabel,
                // RuleBuilder.tsx resolveDisplayText), nunca aqui.
                label: String(column.label || column.name || ""),
                columnType: String(column.column_type || column.columnType || ""),
                isMandatory: Boolean(column.is_mandatory ?? column.isMandatory),
            }))
            .filter((column) => Boolean(column.name));
    }, [allColumns, tables, targetTable]);
};

